<template>
  <main-layout/>
</template>

<script>
  import MainLayout from './components/Layout/Main'
export default {
  components: {
    MainLayout
  }
}

</script>